export enum ButtonAdapterDataHooks {
  SPINNER = 'booking-details-spinner',
  BOOK_NOW_CTA = 'booking-details-book-now-cta',
  ADD_TO_CART_CTA = 'booking-details-add-to-cart-cta',
  BUY_A_PLAN_CTA = 'booking-details-buy-a-plan-cta',
}

export enum ButtonsContainerDataHooks {
  NO_AVAILABLE_PLANS_MESSAGE = 'booking-details-no-available-plans-message',
}
